import { TPendingBlobFile } from '../../types/file';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { IWsFileMessage } from '../wsMessage/types';

export enum EFilesActionTypes {
  UploadPending = 'chat/files/uploadPending',
  UploadSucceed = 'chat/files/uploadSucceed',
  UploadFailed = 'chat/files/uploadFailed',
  WsSendSucceed = 'chat/files/wsSendSucceed',
}

export type TFilesUploadPayload = {
  chatId: string;
  uid: string;
};

export type TFilesUploadPendingPayload = {
  blobFiles: TPendingBlobFile[];
} & TFilesUploadPayload;

export type TFilesUploadSucceedPayload = {
  uploadedFiles: IWsFileMessage[];
} & TFilesUploadPayload;

export type TFilesActions =
  | ITypedReduxAction<EFilesActionTypes.UploadPending, TFilesUploadPendingPayload>
  | ITypedReduxAction<EFilesActionTypes.UploadSucceed, TFilesUploadSucceedPayload>
  | ITypedReduxAction<EFilesActionTypes.UploadFailed, TFilesUploadPayload>
  | ITypedReduxAction<EFilesActionTypes.WsSendSucceed, TFilesUploadPayload>;
